import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './styles/ProfileLink.css';

/**
 * A member's name or avatar that opens their profile.
 * ConnectUserProfile sends your own id on to /connect/profile.
 *
 * Use `nested` inside a <button>, where a real <a> is invalid HTML.
 * Clicks never reach a clickable parent, such as a meetup card.
 */
export default function ProfileLink({ userId, nested, avatar, className = '', onClick, children }) {
  const navigate = useNavigate();
  const to = `/connect/user/${userId}`;
  const classes = `${avatar ? 'connect-profile-link-avatar' : 'connect-profile-link'} ${className}`.trim();

  if (!userId) return <>{children}</>;

  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) onClick(e);
  };

  if (nested) {
    const open = (e) => {
      e.preventDefault();
      handleClick(e);
      navigate(to);
    };
    return (
      <span
        role="link"
        tabIndex={avatar ? -1 : 0}
        className={classes}
        onClick={open}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') open(e); }}
      >
        {children}
      </span>
    );
  }

  return (
    <Link to={to} className={classes} onClick={handleClick} tabIndex={avatar ? -1 : undefined}>
      {children}
    </Link>
  );
}
